import axios from "axios";

export class AuthUtils {
    static readonly accountNumberRegex = /^#?(SP)?\d+(?:-\d+)?$/i;

    static async setAuthStatus(secret: string, accessLevel?: string): Promise<boolean> {
        try {
            const response = await axios.post(
                "/api/set-auth",
                {
                    secret: secret,
                    accessLevel: accessLevel
                },
                {
                    withCredentials: true
                }
            );
            return response.status === 200;
        } catch (error) {
            // Log the error or handle it as needed
            if (axios.isAxiosError(error) && !!error.response?.data) {
                console.log(error.response?.data);
            }
            return false;
        }
    }

    static async verifyAuthStatus(accessLevel?: string): Promise<boolean> {
        try {
            const response = await axios.post("/api/verify-auth", { accessLevel }, { withCredentials: true });
            return response.status === 200;
        } catch (error) {
            if (axios.isAxiosError(error) && !!error.response?.data) {
                console.log(error.response?.data);
            }
            return false;
        }
    }

    static extractAccountNumber(accountNumber: string | undefined): string | null {
        if (!accountNumber) return null;

        // Remove leading # if present
        const withoutHash = accountNumber.replace(/^#/, "");

        const matches = withoutHash.match(this.accountNumberRegex);

        if (matches) {
            let extracted = matches[0];
            // Ensure 'SP' is present at the beginning, regardless of case. If not, add it.
            if (!extracted.toUpperCase().startsWith("SP")) {
                extracted = "SP" + extracted;
            }
            return extracted.toUpperCase();
        }

        return null;
    }

    static isValidEmail(email: string) {
        const regex =
            /^(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])$/i;
        return regex.test(email);
    }
}
